// extracted by mini-css-extract-plugin
module.exports = {"title":"SelectServicePage_title__j0CNH","paddingContainer":"SelectServicePage_paddingContainer__cMDBo","outerContainer":"SelectServicePage_outerContainer___EAm7"};